/* IgelkottPlates collections-page — Eric 2026-05-11 (rev138).
 *
 * /pages/collections management-page. Beror på igelkott-collections.js
 * (laddad via theme.liquid) som exporterar window.igelkott.collections-
 * API. Detta script lägger till page-specifik list/edit/delete/share-UI.
 *
 * Datakälla: localStorage (MVP) via igelkott-collections.js. Server-sync
 * via /apps/igelkott/collections kommer i rev139.
 */
(function () {
  'use strict';

  const log = (window.igelkott && window.igelkott.log) || {
    debug: () => {}, info: () => {},
    warn: console.warn.bind(console), error: console.error.bind(console),
  };

  const page = document.querySelector('[data-igelkott-collections-page]');
  if (!page) return;

  const collectionsAPI = window.igelkott && window.igelkott.collections;
  if (!collectionsAPI || collectionsAPI.isAnonymous) {
    // Auth-required is rendered by Liquid; no JS-side action needed
    return;
  }

  // ── DOM refs ───────────────────────────────────────────────────────────
  const grid = page.querySelector('[data-collections-grid]');
  const emptyEl = page.querySelector('[data-collections-empty]');
  const countEl = page.querySelector('[data-collections-count]');
  const newBtn = page.querySelector('[data-collections-new]');
  const newForm = page.querySelector('[data-collections-new-form]');
  const newNameInput = page.querySelector('[data-collections-page-new-name]');
  const newNameCount = page.querySelector('[data-collections-page-new-name-count]');
  const newCancelBtn = page.querySelector('[data-collections-page-new-cancel]');
  const newSubmitBtn = page.querySelector('[data-collections-page-new-submit]');

  const shareModal = page.querySelector('[data-collections-share-modal]');
  const shareNameEl = page.querySelector('[data-share-name]');
  const shareUrlEl = page.querySelector('[data-share-url]');
  const shareCopyBtn = page.querySelector('[data-share-copy]');
  const shareStatusEl = page.querySelector('[data-share-status]');
  const shareCloseEls = page.querySelectorAll('[data-share-close]');

  // ── Rendering ──────────────────────────────────────────────────────────
  function fmtDate(iso) {
    if (!iso) return '';
    try {
      const d = new Date(iso);
      const now = new Date();
      const diff = (now - d) / 1000;
      if (diff < 60) return 'Just now';
      if (diff < 3600) return Math.floor(diff / 60) + ' min ago';
      if (diff < 86400) return Math.floor(diff / 3600) + ' h ago';
      if (diff < 86400 * 7) return Math.floor(diff / 86400) + ' d ago';
      return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
    } catch (_) {
      return iso;
    }
  }

  function renderList() {
    if (!grid) return;
    const all = collectionsAPI.getCollections();
    if (countEl) countEl.textContent = String(all.length);

    if (all.length === 0) {
      grid.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;

    grid.innerHTML = '';
    all.forEach((c) => {
      const li = document.createElement('li');
      li.className = 'igelkott-collections-page__card';
      li.dataset.collectionId = c.id;
      const plateCount = c.added_handles.length;
      /*
        Eric 2026-05-11 (rev151) — cover_url resolvas nu backend-side
        via productByHandle (Admin GraphQL). Cachas i metafield så bara
        första GET per cover-handle gör fetch. Theme renderar <img> om
        c.cover_url finns, annars placeholder.
      */
      const coverImg = c.cover_url
        ? `<img src="${c.cover_url}" alt="" loading="lazy">`
        : `<div class="igelkott-collections-page__card-cover-placeholder">
             <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg>
           </div>`;
      li.innerHTML = `
        <a href="/?collection=${encodeURIComponent(c.id)}" class="igelkott-collections-page__card-cover">
          ${coverImg}
        </a>
        <div class="igelkott-collections-page__card-body">
          <h3 class="igelkott-collections-page__card-name" data-card-name></h3>
          <div class="igelkott-collections-page__card-meta">
            <span>${plateCount} plate${plateCount === 1 ? '' : 's'}</span>
            <span class="igelkott-collections-page__card-meta-dot">·</span>
            <span>Updated ${fmtDate(c.updated_at)}</span>
          </div>
          <div class="igelkott-collections-page__card-actions">
            <a href="/?collection=${encodeURIComponent(c.id)}" class="igelkott-collections-page__card-action">
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
              View
            </a>
            <button type="button" class="igelkott-collections-page__card-action" data-card-action="rename">
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
              Rename
            </button>
            <button type="button" class="igelkott-collections-page__card-action igelkott-collections-page__card-action--share" data-card-action="share">
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
              Share
            </button>
            <button type="button" class="igelkott-collections-page__card-action igelkott-collections-page__card-action--delete" data-card-action="delete">
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-2 14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L5 6"/></svg>
              Delete
            </button>
          </div>
        </div>
      `;
      li.querySelector('[data-card-name]').textContent = c.name;
      grid.appendChild(li);
    });
  }

  // ── New-collection-form ────────────────────────────────────────────────
  function toggleNewForm(show) {
    if (!newForm) return;
    newForm.hidden = !show;
    if (show && newNameInput) {
      newNameInput.value = '';
      if (newNameCount) newNameCount.textContent = '0';
      if (newSubmitBtn) newSubmitBtn.disabled = true;
      setTimeout(() => newNameInput.focus(), 50);
    }
  }

  if (newBtn) newBtn.addEventListener('click', () => toggleNewForm(true));
  if (newCancelBtn) newCancelBtn.addEventListener('click', () => toggleNewForm(false));

  if (newNameInput) {
    newNameInput.addEventListener('input', () => {
      const v = newNameInput.value || '';
      if (newNameCount) newNameCount.textContent = String(v.length);
      if (newSubmitBtn) newSubmitBtn.disabled = !v.trim();
    });
    newNameInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && newNameInput.value.trim()) {
        e.preventDefault();
        handleNewSubmit();
      }
    });
  }

  if (newSubmitBtn) newSubmitBtn.addEventListener('click', handleNewSubmit);

  function handleNewSubmit() {
    const name = (newNameInput && newNameInput.value || '').trim();
    if (!name) return;
    try {
      collectionsAPI.createCollection(name);
      toggleNewForm(false);
      renderList();
    } catch (err) {
      alert(err.message);
    }
  }

  // ── Card actions ───────────────────────────────────────────────────────
  if (grid) {
    grid.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-card-action]');
      if (!btn) return;
      const card = btn.closest('.igelkott-collections-page__card');
      const id = card && card.dataset.collectionId;
      if (!id) return;
      const action = btn.dataset.cardAction;
      const collection = collectionsAPI.getCollections().find((c) => c.id === id);
      if (!collection) return;

      if (action === 'delete') {
        if (!confirm(`Delete collection "${collection.name}"? This cannot be undone.`)) return;
        deleteCollection(id);
        renderList();
      } else if (action === 'rename') {
        startRename(card, collection);
      } else if (action === 'share') {
        openShareModal(collection);
      }
    });
  }

  function deleteCollection(id) {
    /*
      Eric 2026-05-11 (rev159) — använd proper public API som
      muterar in-memory Map + saveToStorage() + scheduleServerSync().
      Tidigare hack skrev bara localStorage + reload, vilket race-
      condition:ade mot pullServerSync (server hann inte få PUT:en
      → returnerade fortfarande den raderade collection vid reload →
      card försvann och kom tillbaka).
    */
    if (typeof collectionsAPI.deleteCollection === 'function') {
      collectionsAPI.deleteCollection(id);
    } else {
      // Fallback för rev158 och äldre theme-pushar
      log.warn('collections.delete_no_api', { id });
      const all = collectionsAPI.getCollections();
      const remaining = all.filter((c) => c.id !== id);
      try { localStorage.setItem('igelkott.collections.v1', JSON.stringify(remaining)); } catch (_) {}
      window.location.reload();
    }
  }

  function startRename(card, collection) {
    const nameEl = card.querySelector('[data-card-name]');
    if (!nameEl || nameEl.tagName === 'INPUT') return;
    const input = document.createElement('input');
    input.type = 'text';
    input.className = 'igelkott-collections-page__card-name-input';
    input.value = collection.name;
    input.maxLength = 80;
    input.dataset.cardName = '';
    nameEl.replaceWith(input);
    input.focus();
    input.select();

    function commit() {
      const newName = input.value.trim();
      if (newName && newName !== collection.name) {
        renameCollection(collection.id, newName);
      }
      renderList();
    }
    function cancel() { renderList(); }

    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { e.preventDefault(); commit(); }
      if (e.key === 'Escape') { e.preventDefault(); cancel(); }
    });
    input.addEventListener('blur', commit);
  }

  function renameCollection(id, newName) {
    /*
      Rev159 — använd proper public API. Tidigare manuell Map-mutation
      via getCollections-array fungerade av tur (objektreferensen var
      delad), men förlitade sig på implementation-details och bypassade
      scheduleServerSync. Nu går det rätt väg.
    */
    if (typeof collectionsAPI.renameCollection === 'function') {
      try {
        collectionsAPI.renameCollection(id, newName);
      } catch (err) {
        log.warn('collections.rename_failed', { id, error: err.message });
      }
    } else {
      log.warn('collections.rename_no_api', { id });
      const all = collectionsAPI.getCollections();
      const found = all.find((c) => c.id === id);
      if (!found) return;
      found.name = newName.slice(0, 80);
      found.updated_at = new Date().toISOString();
      try { localStorage.setItem('igelkott.collections.v1', JSON.stringify(all)); } catch (_) {}
      document.dispatchEvent(new CustomEvent('igelkott-collections-changed', { detail: { reason: 'renamed', id } }));
    }
  }

  // ── Share modal ────────────────────────────────────────────────────────
  /*
    Rev143 update: real backend share-tokens via POST /collections/share.
    Token persisteras i SQLite + cover-URL pre-resolvas via Admin GraphQL.
    Vid första Share-klick → POST → server returnerar token. Spara token
    på lokal collection för idempotens.
  */
  async function openShareModal(collection) {
    if (!shareModal) {
      log.error('collections.share_no_modal');
      return;
    }
    if (!collection || !collection.id) {
      log.error('collections.share_no_collection', { collection });
      return;
    }

    if (shareNameEl) shareNameEl.textContent = collection.name || '(unnamed)';
    if (shareUrlEl) shareUrlEl.value = 'Generating share link…';
    if (shareStatusEl) shareStatusEl.hidden = true;

    shareModal.hidden = false;
    shareModal.setAttribute('aria-modal', 'true');

    // Hämta eller skapa server-side token
    let token = collection.share_token;
    if (!token) {
      try {
        const r = await fetch('/apps/igelkott/collections/share', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ collection_id: collection.id }),
        });
        if (!r.ok) {
          const text = await r.text().catch(() => '');
          log.error('collections.share_create_failed', { status: r.status, body: text.slice(0, 200) });
          if (shareUrlEl) shareUrlEl.value = '';
          if (shareStatusEl) {
            shareStatusEl.textContent = 'Could not create share link. Please try again.';
            shareStatusEl.dataset.tone = 'err';
            shareStatusEl.hidden = false;
          }
          return;
        }
        const j = await r.json();
        token = j.token;
        /*
          Eric 2026-05-11 (rev160) — memoizea token via proper API.
          Tidigare hack skrev direkt localStorage utan saveToStorage()
          → metafield fick aldrig tokenet → vid reload tappades det →
          nästa Share-klick gjorde onödig ny POST (idempotent server
          räddade UX men inkonsistent state).

          setShareToken muterar Map + saveToStorage → debouncad PUT till
          metafield. Lokal collection-objekt-mutation kvar för share-modal
          state (objektreferens delad med Map).
        */
        collection.share_token = token;
        if (typeof collectionsAPI.setShareToken === 'function') {
          collectionsAPI.setShareToken(collection.id, token);
        } else {
          // Fallback för äldre theme-pushar
          log.warn('collections.share_token_no_api', { id: collection.id });
          try {
            const all = collectionsAPI.getCollections();
            const found = all.find((c) => c.id === collection.id);
            if (found) found.share_token = token;
            localStorage.setItem('igelkott.collections.v1', JSON.stringify(all));
          } catch (_) {}
        }
      } catch (err) {
        log.error('collections.share_create_network', { error: err.message });
        if (shareUrlEl) shareUrlEl.value = '';
        if (shareStatusEl) {
          shareStatusEl.textContent = 'Network error. Please try again.';
          shareStatusEl.dataset.tone = 'err';
          shareStatusEl.hidden = false;
        }
        return;
      }
    }

    /*
      Eric 2026-05-11 (rev162) — share-URL går nu via proxy-endpoint
      /apps/igelkott/share/<token> som returnerar OG-rich HTML för
      WhatsApp/Slack/iMessage-link-preview (collection-specifik
      name + cover_image), och redirectar riktiga users till
      /pages/collection?t=<token>.
    */
    const origin = window.location.origin;
    const url = `${origin}/apps/igelkott/share/${encodeURIComponent(token)}`;
    if (shareUrlEl) shareUrlEl.value = url;

    log.info('collections.share_opened', { id: collection.id, token: token.slice(0, 6) + '...' });
  }

  function closeShareModal() {
    if (!shareModal) return;
    shareModal.hidden = true;
    shareModal.setAttribute('aria-modal', 'false');
    if (shareStatusEl) shareStatusEl.hidden = true;
    log.debug('collections.share_closed');
  }

  /*
    Rev140: robust close-binding. Eric-rapport: X-button click stängde
    inte modal. Möjliga orsaker: shareCloseEls querySelectorAll fångade
    bara innan DOM redo, eller event-bubble-stopped av annan handler.
    Lösning: delegerad click-handler på shareModal-rooten med target-
    matchning, plus direkta bindings via for-each. Båda lyssnare aktiva.
  */
  shareCloseEls.forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      closeShareModal();
    });
  });
  if (shareModal) {
    shareModal.addEventListener('click', (e) => {
      // Backdrop-klick eller close-button-klick (via delegation)
      const closeBtn = e.target.closest('[data-share-close]');
      if (closeBtn || e.target === shareModal) {
        e.preventDefault();
        e.stopPropagation();
        closeShareModal();
      }
    });
  }

  if (shareCopyBtn) {
    shareCopyBtn.addEventListener('click', async () => {
      if (!shareUrlEl) return;
      try {
        await navigator.clipboard.writeText(shareUrlEl.value);
        if (shareStatusEl) {
          shareStatusEl.textContent = '✓ Copied to clipboard.';
          shareStatusEl.hidden = false;
        }
      } catch (err) {
        shareUrlEl.select();
        document.execCommand('copy');
        if (shareStatusEl) {
          shareStatusEl.textContent = '✓ Copied (fallback).';
          shareStatusEl.hidden = false;
        }
      }
      setTimeout(() => {
        if (shareStatusEl) shareStatusEl.hidden = true;
      }, 2500);
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && shareModal && !shareModal.hidden) closeShareModal();
  });

  // ── Init + re-render on state changes ──────────────────────────────────
  renderList();
  document.addEventListener('igelkott-collections-changed', renderList);
})();
